import { matchPath, useLocation } from 'react-router-dom'
import ROUTE_PATTERNS from '../consts/routes'

/**
 * Determines the current route key based on the provided pathname or the current location.
 * Iterates through the predefined ROUTE_PATTERNS to find the first matching pattern.
 * 
 * @param {string} [pathname] - Optional pathname to match against. Defaults to current location.
 * @returns {string|null} The matching route pattern string, or null if no match is found.
 */
const useCurrentRouteKey = (pathname) => {
    const location = useLocation()
    const matchRoute = path => matchPath(pathname || location?.pathname, path)

    // return the first matching route key
    for (const [, pattern] of Object.entries(ROUTE_PATTERNS)) {
        if (matchRoute(pattern)) {
            // root pattern is the same as the dashboard pattern
            return pattern === ROUTE_PATTERNS.ROOT ? ROUTE_PATTERNS.DASHBOARD : pattern
        }
    }
    return null
}

export default useCurrentRouteKey